import ScrollWrapper from "../../../Components/ScrollWrapper";
import Text from "../../../Components/Text";
import SmallImage from "../../../Components/SmallImage";
import Icon from "../../../Components/Icon";
import ChapterToggler from "../../../Components/ChapterToggler";

const CreateCategory = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Kategorien Verwalten</Text>

                <Text type="itemtext">
                    Kategorien sind Gruppen, in welchen sich mehrere Produkte befinden können.
                </Text>

                <SmallImage src={"instructions/category-main.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Modus Wechsler</Text>
                    <Text type="title">2. Neue Kategorie erstellen</Text>
                    <Text type="title">3. Alle Kategorien</Text>
                    <Text type="title">4. Editieren / Löschen</Text>
                </div>

                {/* 1. Modus Wechsler */}
                <ChapterToggler title="1. Modus Wechsler">
                    <Text type="itemtext">
                        Der Modus-Wechsler ist dafür da, zwischen
                        <b> aktiven </b> und <b> inaktiven </b> Kategorien zu wechseln.
                        Standardmässig ist dieser auf <b>Aktiv</b> eingestellt.
                    </Text>

                    <Text type="itemtext">
                        Wird eine aktive Kategorie gelöscht, landet sie im Modus
                        <b> Inaktiv </b> und kann jederzeit wieder reaktiviert werden.
                    </Text>
                </ChapterToggler>

                {/* 2. Neue Kategorie erstellen */}
                <ChapterToggler title="2. Neue Kategorie erstellen">
                    <Text type="itemtext">
                        Durch das Drücken auf diesen Knopf öffnet sich folgendes Formular:
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/category-create.png"}
                        smallSize="w-1/3"
                        subtitle="Kategorie Formular"
                    />

                    <br />

                    <Text type="itemtext">
                        Folgende Eigenschaften können definiert werden:
                    </Text>

                    <Text type="itemtext">
                        <b>Name:</b> Name der Kategorie
                    </Text>
                    <Text type="itemtext">
                        <b>Farbe:</b> Die Farbe, in der die Kategorie und deren Produkte
                        an der Kasse angezeigt werden.
                    </Text>
                </ChapterToggler>

                {/* 3. Alle Kategorien */}
                <ChapterToggler title="3. Alle Kategorien">
                    <Text type="itemtext">
                        Hier werden alle Kategorien aufgelistet, abhängig vom aktuell
                        ausgewählten Modus (Aktiv oder Inaktiv).
                    </Text>
                </ChapterToggler>

                {/* 4. Editieren / Löschen */}
                <ChapterToggler title="4. Editieren / Löschen">
                    <Text type="itemtext">
                        Diese Knöpfe ermöglichen es, Kategorien zu bearbeiten oder zu löschen.
                        Beim Editieren öffnet sich dasselbe Formular wie beim Erstellen.
                    </Text>

                    <Text type="itemtext">
                        Wird eine aktive Kategorie gelöscht, landet sie im Modus
                        <b> Inaktiv </b>. Dabei werden auch alle Produkte dieser Kategorie
                        deaktiviert.
                    </Text>

                    <Text type="itemtext">
                        Im Modus <b>Inaktiv</b> steht zusätzlich der
                        <Icon iconName={"refresh.svg"} classNames="inline w-8 mx-2" />
                        Knopf zur Verfügung, um die Kategorie wieder zu reaktivieren.
                    </Text>

                    <Text type="itemtext">
                        Wird eine Kategorie im Modus Inaktiv erneut gelöscht,
                        wird sie inklusive aller Produkte <b>dauerhaft entfernt</b>.
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/category-deactivated.png"}
                        smallSize="w-full"
                        subtitle="Inaktive Kategorie"
                    />
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default CreateCategory;
